import styled from "styled-components"
import { Panel } from "@xingternal/winery-ui/lib/Panel"

const PanelWrapper = styled(Panel)`
  width: 1008px;
  max-width: 100%;
`

PanelWrapper.defaultProps = {
  mt: 5,
}

export default PanelWrapper
